import { defineStore } from "pinia";
import { logger } from '@/utils/logger';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/config/languages';

export const useI18nStore = defineStore('i18n', {
    state: () => ({
        messages: {},
        supportedLocales: Object.keys(SUPPORTED_LANGUAGES),
        locale: DEFAULT_LANGUAGE
    }),
    getters: {
        userPreferredLocale: (state) => {
            const userLocale = navigator.language || navigator.userLanguage;

            return state.supportedLocales.includes(userLocale) ? userLocale : state.supportedLocales[0];
        }
    },
    actions: {
        async loadLanguage(language) {
            if (!this.messages[language]) {
                try {
                    const response = await fetch(`/locales/${language}.json`);
                    if (!response.ok) {
                        throw new Error('Failed to fetch translation');
                    }
                    const messages = await response.json();
                    this.messages[language] = messages;
                } catch (error) {
                    logger.error('Error loading language:', error);
                    throw error;
                }
            }
        },
        setLocale(language) {
            if (this.supportedLocales.includes(language)) {
                this.locale = language;
            } else {
                logger.warn(`Unsupported locale: ${language}, falling back to ${DEFAULT_LANGUAGE}`);
                this.locale = DEFAULT_LANGUAGE;
            }
        }
    }
})